import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DATA_VIZ_COLORS } from "../../../config/chartColors";
import type { LessonTimeInvestment } from "../../../generated/graphql";

interface TimeInvestmentChartProps {
  data: LessonTimeInvestment[];
}

export function TimeInvestmentChart({ data }: TimeInvestmentChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No time investment data available</div>
      </div>
    );
  }

  const chartData = data.map((lesson) => ({
    name: lesson.lessonName,
    timeMinutes: lesson.totalTimeMinutes,
    sessions: lesson.sessionCount,
    avgMinutes: lesson.averageSessionMinutes,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Time Investment</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" angle={-45} textAnchor="end" height={100} />
            <YAxis label={{ value: "Minutes", angle: -90, position: "insideLeft" }} />
            <Tooltip
              formatter={(value: number | undefined) => (value !== undefined ? `${value} min` : "")}
              contentStyle={{ backgroundColor: "white", border: "1px solid #ccc" }}
            />
            <Legend />
            <Bar dataKey="timeMinutes" fill={DATA_VIZ_COLORS.primary} name="Total Time (min)" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
